import { mainApp } from  '../../../../../resources/js/app.js';
import './filters/datePriceFormatter';
import Vue from 'vue';

Vue.component(
    "search-component",
    require("./components/Search/SearchComponent.vue").default
);

Vue.component(
    "search-filters",
    require("./components/Search/SearchFilterComponent.vue").default
);

Vue.component(
    "data-picker",
    require("./components/DataPicker/DataPickerComponnent.vue").default
);

Vue.component(
    "home-slider",
    require("./components/Home/HomeSliderComponent.vue").default
);

Vue.component(
    "v-activity-slider",
    require("./components/Home/ActivitySliderComponent.vue").default
);
Vue.component(
    "why-family-slider",
    require("./components/Home/WhyFamilySliderComponent.vue").default
);

Vue.component(
    "session-calendar-expander",
    require("./components/ActivityPage/ActivitySessionCalendarExpanderComponant.vue")
        .default
);
Vue.component(
    "activity-date-time",
    require("./components/ActivityPage/ActivityDateTimeComponent.vue").default
);
Vue.component(
    "image-viewer",
    require("./components/ActivityPage/ImageViewerComponent.vue").default
);
Vue.component(
    "v-photoswipe-gallery",
    require("./components/ActivityPage/photoswipe-gallery.vue").default
);
Vue.component(
    "v-photoswipe-company",
    require("./components/ActivityPage/photoswipe-company.vue").default
);
Vue.component(
    "activity",
    require("./components/ActivityPage/ActivityContComponent.vue").default
);
Vue.component(
    "image-viewer-company",
    require("./components/ActivityPage/CompanySliderComponent.vue").default
);
Vue.component(
    "session-calendar",
    require("./components/ActivityPage/ActivitySessionCalendarComponant.vue")
        .default
);


Vue.component(
    "add-review-button",
    require("./components/AddReviewButton/AddReviewButton.vue")
        .default
);

Vue.component(
    "review-dialog",
    require("../../../../Customer/Resources/assets/js/components/Review/ReviewComponent.vue")
        .default
);

Vue.component(
    "editor-ex",
    require("../../../../Organizer/Resources/assets/js/components/Dashboard/EditorComponent.vue")
        .default
);


Vue.component(
    "autocomp-google",
    require("../../../../Organizer/Resources/assets/js/components/FormFields/AutocompGoogleComponent.vue")
        .default
);


Vue.component(
    "vuetify-google-autocomplete",
    require("../../../../Organizer/Resources/assets/js/components/FormFields/VueGoogleAutocompleteComponent.vue")
        .default
);


Vue.component(
    "single-image-upload",
    require("../../../../Organizer/Resources/assets/js/components/FormFields/SingleImageUploaderComponent.vue")
        .default
);


Vue.component(
    "multi-image-upload",
    require("../../../../Organizer/Resources/assets/js/components/FormFields/MultiImageUploadComponent.vue")
        .default
);

Vue.component(
    "number-input",
    require("../../../../Customer/Resources/assets/js/components/FormFields/NumberInputComponent.vue").default
);

Vue.component(
    "tripshop",
    require("./components/Shop/Index.vue").default
);
// Get the current authenticated user info and add it to vue later 
// we can get the current user info in any vue component using this.$user
Vue.prototype.$user = JSON.parse(document.querySelector("meta[name='user']").getAttribute('content'));

new Vue({
    el: "#app",
    mixins: [mainApp],
    name: 'front',
    data: {
        search: "",
        sortby: "popularity",
        searchDate: "",
        searchAge: [],
        searchTime: [],
        searchCategory: [],
        searchCity: [],
        searchDistrict: [],
    },
    methods: {
        dateSearch(date) {
            if (this.searchDate == date) {
                this.searchDate = "";
            } else {
                this.searchDate = date;
            }
        },
        ageSearch(age) {
            if (this.searchAge.indexOf(age) === -1) {
                this.searchAge.push(age);
            } else {
                const index = this.searchAge.indexOf(age);
                if (index > -1) {
                    this.searchAge.splice(index, 1);
                }
            }
        },
        clearAgeSearch() {
            this.searchAge = [];
        },
        timeSearch(time) {
            this.searchTime = time;
        },
        categorySearch(category) {
            this.searchCategory = category;
        },
        citySearch(city) {
            this.searchCity = city;
        },
        districtSearch(district) {
            this.searchDistrict = district;
        },
        termSearching(data) {
          Fire.$emit('term-searching', data);
        },
        removeClasses(className, classType) {
            if (this.searchDate == classType || classType == "custom") {
                var elements = document.getElementsByClassName(className);
                while (elements.length > 0) {
                    elements[0].classList.remove(className);
                }
            }
        },
    },
    filters: {
      test: function() { console.log(test);},
    }
});


    